import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { SearchBarMobileService } from '@search-bar/services/search-bar-mobile.service';
import {
  PackagesDestinationAbstractComponent
} from '@packages/packages-search-bar/abstract/packages-destination.component.abstract';
import { InputTextSize } from '@design-system/components/molecules/input-text/entities/input-text.types';
import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';

@Component({
  selector: 'app-packages-destination-desktop',
  templateUrl: './packages-destination-desktop.component.html',
  styleUrls: ['./packages-destination-desktop.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PackagesDestinationDesktopComponent extends PackagesDestinationAbstractComponent {

  @Input() isResultsPage = false;
  @Input() isHotelDetail = false;
  @Input() isHotelPackageView = false;

  public readonly iconLocation = Icon.Location;
  public readonly iconStarPoint= Icon.StartPoint;

  constructor(
    protected searchBarMobileService: SearchBarMobileService
  ) {
    super(searchBarMobileService);
  }

  get inputSize(): InputTextSize {
    return this.isResultsPage || this.isHotelDetail ? InputTextSize.MD : InputTextSize.RG;
  }

  get filled(): boolean {
    return !this.isResultsPage && !this.isHotelDetail;
  }

  get staticFilled(): boolean {
    return this.isResultsPage || this.isHotelDetail;
  }

}
